export function OutlineCompassIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8872 21C16.8578 21 20.8872 16.9706 20.8872 12C20.8872 7.02944 16.8578 3 11.8872 3C6.91664 3 2.88721 7.02944 2.88721 12C2.88721 16.9706 6.91664 21 11.8872 21Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M15.3288 8.37109L10.4376 10.6223L8.44556 15.6287L13.3368 13.3775L15.3288 8.37109Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
